module.exports = __webpack_public_path__ + "img/tiktok.356aa35b.svg";